// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODIFIED DATA : 07-12-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import BranchProfileReportActionTypes from './branch-profile-report.types';
import { branchProfileReportGet } from './branch-profile-report.service';
import {
	getBranchProfileReportSuccess,
	getBranchProfileReportFailure,
	getBranchProfileReportResponseChanged,
} from './branch-profile-report.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/***********************  START - GET BRANCH PROFILE REPORT  DETAILS  ******************** */
export function* getBranchProfileReport({ payload }: any) {
	try {
		const {
			companyID,
			userID,
			userRole,
			userLevel,
			branchID,
			databaseName,
			fetchProfileDate,
			selectTab,
		} = payload;
		const key = 'FetchBranchProfileReportKey';
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			BranchID: branchID,
			DatabaseName: databaseName,
			ProfileDate: fetchProfileDate,
			SortbyMethod: selectTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(branchProfileReportGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchProfileReportFailure(responseData.data));
		} else {
			yield put(getBranchProfileReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchProfileReportFailure(error));
	}
}

export function* resetGetBranchProfileReportListResponse() {
	yield put(getBranchProfileReportResponseChanged());
}

export function* onGetBranchProfileReportDetails() {
	yield takeLatest(
		BranchProfileReportActionTypes.GET_BRANCH_PROFILE_REPORT_START,
		getBranchProfileReport,
	);
}

export function* onGetBranchProfileReportResponseReset() {
	yield takeLatest(
		BranchProfileReportActionTypes.GET_BRANCH_PROFILE_REPORT_RESPONSE_RESET,
		resetGetBranchProfileReportListResponse,
	);
}
/************************  END - GET BRANCH PROFILE REPORT LIST ************************/

export function* branchProfileReportSaga() {
	yield all([call(onGetBranchProfileReportDetails), call(onGetBranchProfileReportResponseReset)]);
}
